export enum NotificationOptionsEnum {
  None = 0,
  Custom = 1,
  All = 2
}
